import React from "react";
import GamesBody from "./GamesBody";
import GamesHeader from "./GamesHeader";

const GamesfullPage = () => {
  return (
    <div className="bg-dark">
      <GamesHeader />
      <GamesBody />
    </div>
  );
};

export default GamesfullPage;
